@if (databinding().label.length > 0) {
  <span>{{ databinding().label }}</span>
}
<div [class.card]="databinding().dropDownShown">
  @if (!databinding().hideDropDown) {
    <div class="input-group m-0 w-100">
      <input
        [ngModel]="selectedRowDisplayText()"
        type="text"
        class="form-control py-0 select-search"
        readonly
        (click)="popUp()"
      />
      <button class="btn btn-primary m-0 px-2 py-1 dropdown-toggle-width" (click)="dropdownToggle()">
        <i class="fal fa-caret-down" aria-hidden="true"></i>
      </button>
    </div>
  }
  @if (!databinding().data) {
    <div class="text-center pt-2 pb-2">
      <bpw-loader></bpw-loader>
    </div>
  }
  <div class="p-1 w-100" [hidden]="!databinding().data || !databinding().dropDownShown">
    <div class="input-group w-100">
      <span class="input-group-text"><i class="fal fa-search"></i></span>
      <input
        #search
        name="search"
        type="text"
        class="form-control"
        [ngModel]="searchTerm()"
        (ngModelChange)="searchChanged($event)"
        placeholder="{{ databinding().searchName }}"
        autocomplete="off"
      />
      @if (searchTerm().length > 0) {
        <span
          class="input-group-text hand"
          role="button"
          tabindex="0"
          aria-label="Suche leeren"
          (click)="clearSearch()"
          (keydown.enter)="clearSearch()"
        >
          <i class="fal fa-times" aria-hidden="true"></i>
        </span>
      }
      @if (resultLoaderVisible()) {
        <span class="input-group-text">
          <i class="fal fa-spinner fa-spin fa-fw"></i>
        </span>
      }
    </div>
    <table class="table table-hover mb-0">
      @if (databinding().status > 0 && databinding().customColumns) {
        <tbody>
          @for (row of displayedData(); track row) {
            <tr (click)="rowClickedInternal(row)" [class.active-row]="row === selectedRow()" class="b2-row hand">
              @for (col of databinding().customColumns; track col) {
                <td class="py-2 b2-wrap">{{ row[col] }}</td>
              }
            </tr>
          }
        </tbody>
      }
      @if (databinding().status > 0 && !databinding().customColumns) {
        <tbody>
          @for (row of displayedData(); track row) {
            <tr (click)="rowClickedInternal(row)" [class.active-row]="row === selectedRow()" class="b2-row hand">
              <td class="py-2">{{ row.dokument }}</td>
              <td class="py-2 b2-wrap">
                {{ row.bezeichnung }}&nbsp;
                @if (getBauherr(row)) {
                  <div>
                    <i class="fal fa-user" aria-hidden="true"></i>
                    &nbsp;{{ getBauherr(row) }}
                  </div>
                }
              </td>
            </tr>
          }
        </tbody>
      }
      @if (databinding().status <= 0) {
        <tbody>
          <tr>
            @if (databinding().status === 0) {
              <td class="py-2">Keine Daten gefunden</td>
            }
            @if (databinding().status === -1) {
              <td class="text-danger py-2">Fehler beim Abrufen der Daten</td>
            }
            @if (databinding().status === -2) {
              <td class="text-danger py-2">Umsetzung für Custom-Columns noch nicht implementiert</td>
            }
          </tr>
        </tbody>
      }
    </table>
    <bpw-pagination #pagination (selectedPageChanged)="selectedPageChanged($event)"></bpw-pagination>
  </div>
</div>
